import React, { Component } from "react";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import PictureUpload from "components/CustomUpload/ImageUpload.jsx";
import Button from "components/CustomButtons/Button.jsx";
import InputLabel from "@material-ui/core/InputLabel";
import Datetime from "react-datetime";
import NotifList from "granular/Notification/notifList.js";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Select from "@material-ui/core/Select";
import { pushLoader } from "../../actions/main";
import {
  fetchUploadAll,
  deletePort,
  pushUpload,
  proccessUpload
} from "../../api/port";
import { fetchPOIPort, pushPort, updatePort } from "../../api/port";
import Portdt from "../../granular/MasterData/portdt";
import MenuItem from "@material-ui/core/MenuItem";
import moment from "moment";
import _ from "lodash";
import { connect } from "react-redux";
import swal from "sweetalert";
import VesselOwnerdt from "./vesselownerdt";
import {
  deleteCompanyFleet,
  fetchCompany,
  fetchCompanyFleet,
  fetchVessel,
  insertCompanyFleet
} from "../../api/vesselowner";
import { Autocomplete } from "@material-ui/lab";
import { Box, Checkbox, Chip, ListItemText } from "@material-ui/core";
import { Delete, Restore } from "@material-ui/icons";

class VesselOwner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataCompanyFleet: [],
      datatable: this.props.datatable,
      dataVessel: this.props.dataVessel,
      companySelected: {
        company_code: "",
        company_name: ""
      },
      searchCompany: "",
      menuAccess: "all",
      roleAccess: "guest",
      vesselSelected: [],
      vesselListNotSelected: [],
      vesselChoosenToAdd: [],
      vesselChoosenToDelete: [],
      vesselTemporary: "",
      openAdd: false,
      openEdit: false,
      urlfile: "-",
      description: "",
      file_upload: "",
      company_code: localStorage.getItem("company_code"),
      user_id: localStorage.getItem("id"),
      status: "add",
      loader: null,
      isError: false,
      loadingUpdate: false
    };
  }

  UNSAFE_componentWillMount() {
    // console.log(localStorage);
  }

  componentDidMount() {
    //this.getData();
  }

  handleDelete = id => {
    //console.log(id);
    swal({
      icon: "warning",
      title: "Delete",
      text: `Are you sure to delete data port with id: ${id}`,
      buttons: true,
      dangerMode: true
    }).then(willDelete => {
      if (willDelete) {
        deletePort(id)
          .then(response => {
            if (response != null) {
              this.getDatatable();
            }
          })
          .catch(error => {
            // console.log("tidak berhasil");
            this.props.history.push("/pages/login#logout");
          });
      } else {
        // console.log("cancel delete");
      }
    });
  };

  handleClose = (key, value) => {
    this.setState({
      [key]: value
    });
  };

  getData = async () => {
    this.props.pushLoader(true);
    this.setState({ loader: true });
    await fetchCompany()
      .then(response => {
        if (response != null) {
          this.setState({ datatable: response.data.results });
        }
        // this.props.pushLoader(false);
        this.setState({ loader: false });
      })
      .catch(error => {
        this.setState({ loader: false });
        this.props.history.push("/pages/login#logout");
        //this.props.pushToken(error);
      });
    await fetchVessel()
      .then(response => {
        if (response != null) {
          this.setState({ dataVessel: response.data.results });
        }
        // this.props.pushLoader(false);
        this.setState({ loader: false });
      })
      .catch(error => {
        this.setState({ loader: false });
        this.props.history.push("/pages/login#logout");
        //this.props.pushToken(error);
      });
  };

  handleChange = (nameState, value) => {
    this.setState({ [nameState]: value });
  };

  handleChangeDataAccess = async dataVessel => {
    // const {
    //   target: { value },
    // } = e;
    // await this.setState({
    //   vesselSelected: value === "string" ? value.split(",") : value,
    // });
    // console.log(this.state.vesselSelected);

    // let dataVessel = _.find(this.state.dataVessel, {
    //   call_sign: e.target.value,
    // });
    if (dataVessel) {
      let temp = _.differenceWith(
        this.state.vesselListNotSelected,
        [dataVessel],
        (arrVal, othVal) => arrVal.call_sign === othVal.call_sign
      );
      let tempChoosenToAdd = _.cloneDeep(this.state.vesselChoosenToAdd);
      tempChoosenToAdd.push(dataVessel);
      await this.setState({
        vesselListNotSelected: temp,
        vesselChoosenToAdd: tempChoosenToAdd
      });
    }
    // this.setState({
    //   vesselChoosenToAdd:
    // })
  };

  handleFindVessel = call_sign => {
    let temp = _.find(this.props.dataVessel, {
      call_sign: call_sign
    });
    return temp.vessel_name;
  };

  handleChangeCompany = async newValue => {
    // await this.setState({ companySelected: newValue });
    let temp = _.filter(this.state.dataCompanyFleet, {
      company_code: newValue.company_code
    });
    // console.log(temp);
  };

  handleUpdate = async (company_code, company_name) => {
    this.setState({
      vesselChoosenToAdd: [],
      vesselChoosenToDelete: [],
      status: "update"
    });
    this.props.pushLoader(true);
    await fetchCompanyFleet(company_code)
      .then(async response => {
        // console.log(response.data);
        if (response != null) {
          await this.setState({
            dataCompanyFleet: response.data.results,
            openAdd: true,
            companySelected: {
              company_code: company_code,
              company_name: company_name
            }
          });
          let temp = _.filter(this.state.dataCompanyFleet, {
            company_code: company_code
          });
          await this.setState({ vesselSelected: temp });
          // console.log(temp);
          let tempExclude = _.filter(
            this.props.dataVessel,
            this.handleFilterExclude
          );
          let tempExcludeTest = _.differenceWith(
            this.props.dataVessel,
            temp,
            (arrVal, othVal) => arrVal.call_sign === othVal.call_sign
          );
          this.setState({ vesselListNotSelected: tempExcludeTest });
        }
        this.props.pushLoader(false);
        this.setState({ loader: false });
      })
      .catch(error => {
        this.setState({ loader: false });
        this.props.pushLoader(false);
        this.props.history.push("/pages/login#logout");
        //this.props.pushToken(error);
      });
  };

  handleDeleteVessel = dataVessel => {
    let temp = _.differenceWith(
      this.state.vesselSelected,
      [dataVessel],
      (arrVal, othVal) => arrVal.call_sign === othVal.call_sign
    );
    let tempChoosenToDelete = _.cloneDeep(this.state.vesselChoosenToDelete);
    tempChoosenToDelete.push(dataVessel);
    this.setState({
      vesselSelected: temp,
      vesselChoosenToDelete: tempChoosenToDelete
    });
  };

  handleDeleteChoosenToAdd = dataVessel => {
    let temp = _.differenceWith(
      this.state.vesselChoosenToAdd,
      [dataVessel],
      (arrVal, othVal) => arrVal.call_sign === othVal.call_sign
    );
    let vesselList = _.cloneDeep(this.state.vesselListNotSelected);
    vesselList.push(dataVessel);
    vesselList = _.sortBy(vesselList, o => {
      return o.id;
    });
    this.setState({
      vesselChoosenToAdd: temp,
      vesselListNotSelected: vesselList
    });
  };

  handleRestore = dataVessel => {
    let temp = _.differenceWith(
      this.state.vesselChoosenToDelete,
      [dataVessel],
      (arrVal, othVal) => arrVal.call_sign === othVal.call_sign
    );
    let vesselSelected = _.cloneDeep(this.state.vesselSelected);
    vesselSelected.push(dataVessel);
    vesselSelected = _.sortBy(vesselSelected, o => {
      return o.id;
    });
    this.setState({
      vesselChoosenToDelete: temp,
      vesselSelected: vesselSelected
    });
  };

  handleFilterExclude = item => {
    return (
      _.findIndex(this.state.vesselSelected, {
        id: item.id
      }) === -1
    );
  };

  handleSubmit = () => {
    if (
      this.state.name &&
      this.state.address &&
      this.state.description &&
      this.state.district &&
      this.state.subdistrict &&
      this.state.dimensi &&
      this.state.subdimensi &&
      this.state.latitude &&
      this.state.longitude
    ) {
      pushPort(this.state)
        .then(response => {
          if (response != null) {
            this.setState({
              description: "-",
              openAdd: false
            });
            this.getDatatable();
          }
        })
        .catch(error => {
          this.props.history.push("/pages/login#logout");
        });
    } else {
      this.setState({ errorCheck: true });
    }
  };

  handleSubmitUpdate = async () => {
    await this.setState({ loadingUpdate: true });
    for (const item of this.state.vesselChoosenToAdd) {
      let data = {
        companyCode: this.state.companySelected.company_code,
        companyName: this.state.companySelected.company_name,
        callSign: item.call_sign,
        vesselName: item.vessel_name
      };
      await insertCompanyFleet(data)
        .then(res => {
          // console.log(res);
        })
        .catch(err => {
          console.log(err);
          this.setState({ isError: true });
          this.props.history.push("/pages/login#logout");
        });
    }
    for (const item of this.state.vesselChoosenToDelete) {
      await deleteCompanyFleet(item.id)
        .then(res => {
          // console.log(res);
        })
        .catch(err => {
          console.log(err);
          this.setState({ isError: true });
          this.props.history.push("/pages/login#logout");
        });
    }
    // await this.state.vesselChoosenToDelete.forEach((item) => {
    // });
    if (!this.state.isError) {
      this.setState({ openAdd: false, loadingUpdate: false });
    }
  };

  handleFileUpload = event => {
    this.setState({ file_upload: event.target.files[0] });
    //console.log(event.target.files[0].name);

    const ext = event.target.files[0].name.split(".");

    // proccessUpload(event.target.files[0], ext[1])
    //   .then(response => {
    //     this.setState({ urlfile: response.data.url })
    //   })
    //   .catch(error => {
    //     console.log(error);
    //   });
  };

  handleChangeText = (keys, e) => {
    this.setState({ [keys]: e.target.value });
  };

  handleAdd = () => {
    this.setState({
      openAdd: true,
      name: "",
      address: "",
      description: "",
      district: "",
      subdistrict: "",
      dimensi: "",
      subdimensi: "",
      latitude: "",
      longitude: "",
      status: "add",
      errorCheck: false
    });
  };

  renderAction = () => {
    if (this.state.status == "add") {
      return (
        <Button
          // onClick={() => this.handleSubmit()}
          color="success"
          round
        >
          Add
        </Button>
      );
    } else {
      return (
        <Button
          disabled={this.state.isError || this.state.loadingUpdate}
          onClick={() => this.handleSubmitUpdate()}
          color="success"
          round
        >
          {this.state.loadingUpdate ? "Loading" : "Update"}
        </Button>
      );
    }
  };
  handleError = e => {
    if (!e) return true;
    return false;
  };
  handleHelperText = (e, check) => {
    if (this.state.errorCheck) if (check(e)) return "This field is required";
  };

  renderAdd = e => {
    if (localStorage.getItem("userlevel") != 3) {
      return (
        <Button color="success" round onClick={() => this.handleAdd()}>
          Add Data
        </Button>
      );
    } else {
      return <div />;
    }
  };

  render() {
    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            {/* <CardHeader color="rose" icon>
              {this.renderAdd()}
            </CardHeader> */}
            <VesselOwnerdt
              datatable={this.props.datatable}
              handleDelete={this.handleDelete}
              handleUpdate={this.handleUpdate}
              loader={this.state.loader}
            />
          </Card>
          <Dialog
            fullScreen
            open={this.state.openAdd}
            onClose={() => this.handleClose("openAdd", false)}
            aria-labelledby="form-dialog-title"
          >
            <DialogTitle id="form-dialog-title">
              Manage Access - {this.state.companySelected.company_name}
            </DialogTitle>
            <DialogContent>
              <GridContainer>
                {/* <GridItem xs={6} sm={6} md={6}>
                  <InputLabel htmlFor="name-native-disabled">
                    Company
                  </InputLabel>
                  <Autocomplete
                    value={this.state.new}
                    onChange={(event, newValue) => {
                      this.handleChangeCompany(newValue);
                    }}
                    inputValue={this.state.searchCompany}
                    onInputChange={async (event, newInputValue) => {
                      let valuenya = newInputValue.split(") ");
                      await this.setState({
                        searchCompany: newInputValue,
                        // companySelected: valuenya[1]
                      });
                    }}
                    id="programmer-search"
                    options={this.state.datatable}
                    getOptionLabel={(option) =>
                      "(" + option.company_code + ") " + option.company_name
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Search"
                        //variant="filled"
                        style={{ width: "100%", paddingBottom: 1 }}
                      />
                    )}
                  /> */}
                {/* <Select
                    native
                    value={this.state.programer_id}
                    onChange={this.handleChangeProfile}
                    inputProps={{
                      name: "age",
                      id: "age-native-simple"
                    }}
                  >
                    {this.state.profiles.map(this.renderProfiles)}
                  </Select> */}
                {/* </GridItem> */}
                <GridItem xs={6} sm={6} md={6}>
                  <InputLabel htmlFor="name-native-disabled">
                    Menu Access
                  </InputLabel>
                  <Select
                    value={this.state.menuAccess}
                    onChange={e =>
                      this.handleChange("menuAccess", e.target.value)
                    }
                    inputProps={{
                      name: "menuAccess",
                      id: "menuAccess"
                    }}
                    fullWidth
                    style={{ marginTop: 16 }}
                  >
                    <MenuItem value="all">All</MenuItem>
                  </Select>
                </GridItem>
                <GridItem xs={6} sm={6} md={6}>
                  <InputLabel htmlFor="name-native-disabled">
                    Menu Access
                  </InputLabel>
                  <Select
                    value={this.state.roleAccess}
                    onChange={e =>
                      this.handleChange("roleAccess", e.target.value)
                    }
                    inputProps={{
                      name: "roleAccess",
                      id: "roleAccess"
                    }}
                    fullWidth
                    style={{ marginTop: 16 }}
                  >
                    <MenuItem value="administrator">Administrator</MenuItem>
                    <MenuItem value="guest">Guest</MenuItem>
                  </Select>
                </GridItem>
                <GridItem xs={6} sm={6} md={6}>
                  <InputLabel htmlFor="name-native-disabled">Vessel</InputLabel>
                  <Autocomplete
                    onChange={(event, newValue) => {
                      this.handleChangeDataAccess(newValue);
                    }}
                    // inputValue={this.state.vesselTemporary}
                    // onInputChange={async (event, newInputValue) => {
                    //   let valuenya = newInputValue.split(") ");
                    //   await this.setState({
                    //     vesselTemporary: newInputValue,
                    //     // companySelected: valuenya[1]
                    //   });
                    // }}
                    id="search-vessel"
                    options={this.state.vesselListNotSelected}
                    getOptionLabel={option => option.vessel_name}
                    renderInput={params => (
                      <TextField
                        {...params}
                        label="Search"
                        //variant="filled"
                        style={{ width: "100%", paddingBottom: 1 }}
                      />
                    )}
                  />
                </GridItem>
                {/* <GridItem xs={6} sm={6} md={6}>
                  <InputLabel htmlFor="name-native-disabled">
                    Data Access
                  </InputLabel>
                  <Select
                    value={this.state.vesselTemporary}
                    onChange={this.handleChangeDataAccess}
                    inputProps={{
                      name: "vesselTemporary",
                      id: "vesselTemporary",
                    }}
                    fullWidth
                    placeholder="Search Vessel"
                    // renderValue={(selected) => (
                    //   <Box
                    //     style={{
                    //       display: "flex",
                    //       flexDirection: "row",
                    //       flexWrap: "wrap",
                    //       gap: "0.5",
                    //     }}
                    //   >
                    //     {selected.map((value) => (
                    //       <Chip
                    //         key={value}
                    //         label={this.handleFindVessel(value)}
                    //       />
                    //     ))}
                    //   </Box>
                    // )}
                    style={{ marginTop: 16 }}
                  >
                    {this.state.vesselListNotSelected.map((vessel) => (
                      <MenuItem key={vessel.call_sign} value={vessel.call_sign}>
                        <ListItemText primary={vessel.vessel_name} />
                      </MenuItem>
                    ))}
                  </Select>
                </GridItem> */}
                <GridItem xs={6} sm={6} md={6} />
                <GridItem xs={6} sm={6} md={6}>
                  <Box>
                    <p>Selected Vessel to Add</p>
                    <Box
                      style={{
                        width: "100%",
                        height: "300px",
                        overflowY: "scroll",
                        gap: "5px",
                        display: "flex",
                        flexDirection: "column"
                      }}
                    >
                      {this.state.vesselChoosenToAdd.length > 0 ? (
                        this.state.vesselChoosenToAdd.map(item => (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                              padding: "5px 50px",
                              background: "#b2dfdb",
                              borderRadius: "20px",
                              alignItems: "center"
                            }}
                          >
                            <p
                              style={{
                                margin: 0
                              }}
                            >
                              {item.call_sign} - {item.vessel_name}
                            </p>
                            <Button
                              color="danger"
                              onClick={() =>
                                this.handleDeleteChoosenToAdd(item)
                              }
                              disabled={
                                this.state.isError || this.state.loadingUpdate
                              }
                            >
                              <Delete />
                            </Button>
                          </div>
                        ))
                      ) : (
                        <div
                          style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                          }}
                        >
                          <p>Choose Vessel to Add</p>
                        </div>
                      )}
                    </Box>
                    <p>Selected Vessel to Delete</p>
                    <Box
                      style={{
                        // border: "1px solid black",
                        width: "100%",
                        height: "300px",
                        overflowY: "scroll",
                        gap: "5px",
                        display: "flex",
                        flexDirection: "column"
                      }}
                    >
                      {this.state.vesselChoosenToDelete.length > 0 ? (
                        this.state.vesselChoosenToDelete.map(item => (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                              padding: "5px 50px",
                              background: "#b2dfdb",
                              borderRadius: "20px",
                              alignItems: "center"
                            }}
                          >
                            <p
                              style={{
                                margin: 0
                              }}
                            >
                              {item.call_sign} - {item.vessel_name}
                            </p>
                            <Button
                              color="info"
                              onClick={() => this.handleRestore(item)}
                              disabled={
                                this.state.isError || this.state.loadingUpdate
                              }
                            >
                              <Restore />
                            </Button>
                          </div>
                        ))
                      ) : (
                        <div
                          style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                          }}
                        >
                          <p>There's no Vessel to delete</p>
                        </div>
                      )}
                    </Box>
                  </Box>
                </GridItem>
                <GridItem xs={6} sm={6} md={6}>
                  <p>Vessel Company</p>
                  <Box
                    style={{
                      // border: "1px solid black",
                      width: "100%",
                      height: "300px",
                      overflowY: "scroll",
                      gap: "5px",
                      display: "flex",
                      flexDirection: "column"
                    }}
                  >
                    {this.state.vesselSelected.length > 0 ? (
                      this.state.vesselSelected.map(item => (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            padding: "5px 50px",
                            background: "#b2dfdb",
                            borderRadius: "20px",
                            alignItems: "center"
                          }}
                        >
                          <p
                            style={{
                              margin: 0
                            }}
                          >
                            {item.call_sign} - {item.vessel_name}
                          </p>
                          <Button
                            color="danger"
                            onClick={() => this.handleDeleteVessel(item)}
                            disabled={
                              this.state.isError || this.state.loadingUpdate
                            }
                          >
                            <Delete />
                          </Button>
                        </div>
                      ))
                    ) : (
                      <div
                        style={{
                          width: "100%",
                          height: "100%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center"
                        }}
                      >
                        <p>There's no vessel registered in this Company</p>
                      </div>
                    )}
                  </Box>
                </GridItem>
              </GridContainer>
            </DialogContent>
            <DialogActions>
              {this.state.isError && (
                <p
                  style={{
                    color: "red",
                    margin: "0px 10px 0px 0px"
                  }}
                >
                  Update Error, please refresh this page and try again!
                </p>
              )}
              <Button
                onClick={() => this.handleClose("openAdd", false)}
                color="danger"
                round
                disabled={this.state.isError || this.state.loadingUpdate}
              >
                Cancel
              </Button>
              {this.renderAction()}
            </DialogActions>
          </Dialog>
        </GridItem>
      </GridContainer>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

export default connect(
  mapStateToProps,
  { pushLoader }
)(VesselOwner);
